<script lang="ts">
	import { page } from '$app/stores';
	import { env } from '$env/dynamic/public';
	import Logo from '$lib/components/Logo.svelte';
	import { t, locale } from '$lib/translations';

	const lang = locale.get();
</script>

<section>
	<Logo />

	<h1>{$page.status}: {$page.error?.message}</h1>
	{#if $page.status === 401}
		<p>{$t('common.error_401_desc')}</p>
		<a class="button secondary" href="/{lang}">{$t('common.error_401_button')}</a>
	{/if}
	{#if $page.status === 404}
		<p>{$t('common.error_404_desc')}</p>
		<a class="button secondary" href="{env.PUBLIC_WEBSITE_URL}/">{$t('common.error_404_button')}</a>
	{/if}
</section>

<style>
	.button {
		margin-top: 2rem;
		align-self: center;
	}
	h1 {
		font-size: 1.6em;
		font-weight: 700;
		padding-top: 2rem;
	}
	h1,
	p {
		color: var(--burgundy);
		max-width: 30ch;
		text-align: center;
	}
	a {
		text-decoration: none;
	}

	section {
		box-sizing: border-box;
		color: white;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		height: 100vh;
		background: var(--gradient-6);
		border: 1rem solid white;
		border-radius: 2rem;
		gap: 0.5rem;
	}
</style>
